import { useState } from 'react';

// Styles
import './cookieList.scss';
import { Icon } from '@/comp/icon/icon';

export const CookieList = () => {
    const [cookieListOpen, setCookieListOpen] = useState(false);
    const [cookieListDescriptionOpen, setCookieListDescriptionOpen] = useState<Record<string, boolean>>({});

    const cookieList = [
        {
            name: 'CookieConsentCustomerArea',
            domain: 'kundenbereich.aurumtours.de',
            expires: '400 Tage',
            type: 'Cookie',
            provider: 'AurumTours GmbH',
            description: (
                <>
                    Dieses Cookie speichert Ihre Cookie-Einstellungen für diese Website. Diese können Sie jederzeit
                    ändern oder Ihre Einwilligung widerrufen. Des Weiteren enthält dieser Cookie Ihre eindeutige ID,
                    damit eindeutige Besucher auf dieser Website identifiziert werden können.
                </>
            ),
        },
        {
            name: 'loggedIn',
            domain: '.aurumtours.de ',
            expires: 'Nutzer Session',
            type: 'Cookie',
            provider: 'AurumTours GmbH',
            description: <>Domainübergreifende Infomation ob der Nutzer eingeloggt ist.</>,
        },
        {
            name: '_ga',
            domain: '.aurumtours.de',
            expires: '400 Tage',
            type: 'Cookie',
            provider: 'Google LLC',
            description: (
                <>
                    Registriert eine eindeutige ID für einen Website-Besucher, um zu verfolgen, wie der Besucher die
                    Website nutzt. Die Daten werden für Statistiken verwendet. Datenübermittlung in Drittländer: USA.
                    Google LLC. ist nach dem Data Privacy Framework zertifiziert, was bedeutet, dass Ihre Rechte als
                    betroffene Person gewährleistet werden können.
                </>
            ),
        },
        {
            name: '_ga_********',
            domain: '.aurumtours.de',
            expires: '400 Tage',
            type: 'Cookie',
            provider: 'Google LLC',
            description: (
                <>
                    Dieses Cookie speichert eine eindeutige ID für einen Website-Besucher und verfolgt, wie der Besucher
                    die Website nutzt. Die Daten werden für Statistiken verwendet. Datentransfer. in Drittländer: USA.
                    Google LLC. ist nach dem Data Privacy Framework zertifiziert, was bedeutet, dass Ihre Rechte als
                    betroffene Person gewährleistet werden können.
                </>
            ),
        },
        {
            name: '_gid',
            domain: '.aurumtours.de',
            expires: '1 Tage',
            type: 'Cookie',
            provider: 'Google LLC',
            description: (
                <>
                    Dieser Cookie dient der Erhebung von Nutzer-Statistiken für die Webseite. Erhebung von Statistik
                    über die Nutzung der Webseite (Reichweitenmessung). Die Statistiken werden ausgewertet, um auf Basis
                    der Erkenntnisse die Performance der Webseite und die Nutzererfahrung zu verbessern.
                    Browserinformationen (Browsertyp, Referrer-/Exit-Seiten, die auf unserer Website angezeigten
                    Dateien, Betriebssystem, Datums-/Zeitstempel und/oder Clickstream-Daten)Nutzungsdaten (Ansichten,
                    Klicks)IP-Adresse (Wir haben die IP-Anonymisierung auf der Website aktiviert (sog. IP-Masking),
                    sodass Ihre IP-Adresse von Google innerhalb der EU und des EWR vor der Übertragung soweit gekürzt
                    wird, dass sie keine Rückschlüsse mehr auf einzelne Personen zulässt. Lediglich diese anonymisierte
                    IP-Adresse werden an Google übermittelt.)
                </>
            ),
        },
        {
            name: '_gcl_au',
            domain: '.aurumtours.de ',
            expires: '90 Tage',
            type: 'Cookie',
            provider: 'Google LLC',
            description: (
                <>
                    Das Cookie wird vom Google Tag Manager genutzt, um Conversions zu tracken und zu speichern.
                    Informationen zu erreichten Conversionzielen auf der Webseite. Das Tracken und Speichern von
                    Conversions dient der Erfolgsmessung auf der Webseite.
                </>
            ),
        },
    ];

    const renderCookieList = () => {
        return cookieList.map((cookie) => (
            <>
                <tr key={cookie.name} className="cookie-row">
                    <td className="text-bold">{cookie.name}</td>
                    <td>{cookie.domain}</td>
                    <td>{cookie.expires}</td>
                    <td>{cookie.type}</td>
                    <td>{cookie.provider}</td>
                </tr>
                {cookie.description && (
                    <tr className="cookie-description">
                        <td
                            colSpan={6}
                            className="cookie-description-content"
                            onClick={() =>
                                setCookieListDescriptionOpen({
                                    ...cookieListDescriptionOpen,
                                    [cookie.name]: !cookieListDescriptionOpen[cookie.name],
                                })
                            }>
                            <span className="cookie-description-toggle">
                                <Icon
                                    name={
                                        cookieListDescriptionOpen[cookie.name] ? 'keyboardArrowUp' : 'keyboardArrowDown'
                                    }
                                    ariaHidden
                                />

                                {cookieListDescriptionOpen[cookie.name] ? 'Details verbergen' : 'Details anzeigen'}
                            </span>

                            {cookieListDescriptionOpen[cookie.name] && cookie.description}
                        </td>
                    </tr>
                )}
            </>
        ));
    };

    return (
        <>
            <h4>Cookie-Liste</h4>
            <p>
                Diese Liste zeigt alle auf der Webseite vorhandenen Cookies. Sie spiegelt nicht die persönlichen
                Opt-Out-Einstellungen des Users wieder.
            </p>
            <div
                className="cookie-list-toggle"
                onClick={() => {
                    setCookieListOpen(!cookieListOpen);
                }}>
                <Icon name={cookieListOpen ? 'keyboardArrowUp' : 'keyboardArrowDown'} />
                Cookie-Liste dieser Webseite
            </div>
            {cookieListOpen && (
                <table className="cookie-list">
                    <thead>
                        <tr>
                            <th>Cookie-Name</th>
                            <th>Domainname</th>
                            <th>Ablauf</th>
                            <th>Typ</th>
                            <th>Anbieter</th>
                        </tr>
                    </thead>
                    <tbody>{renderCookieList()}</tbody>
                </table>
            )}
        </>
    );
};
